import { render, staticRenderFns } from "./p_invest020.vue?vue&type=template&id=b1fb3efe&scoped=true&"
import script from "./p_invest020.vue?vue&type=script&lang=js&"
export * from "./p_invest020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fb3efe",
  null
  
)

export default component.exports